import { render, staticRenderFns } from "./NoMessagePrompt.vue?vue&type=template&id=6a93c7ec&"
import script from "./NoMessagePrompt.vue?vue&type=script&lang=ts&"
export * from "./NoMessagePrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports